import { deleteCookie, getCookie, setCookie } from "@/hooks/cookie-helper";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { companyServiceApi } from "./service-api";

export const PERSISTED_CURRENT_SERVICE_REF = "nttp_current_service";
export const PERSISTED_CURRENT_SERVICE_ID = "nttp_current_serviceId";

export const getCurrentServiceIdFromCookie = (request: Request) => {
  getCookie(PERSISTED_CURRENT_SERVICE_ID, request.headers.get("cookie") ?? "");
};

export const setCurrentServiceCookie = (sysAccountNo: string) => {
  setCookie({
    name: PERSISTED_CURRENT_SERVICE_REF,
    value: sysAccountNo,
    days: 356,
  });
};

export const deleteCurrentServiceCookie = () => {
  deleteCookie(PERSISTED_CURRENT_SERVICE_REF);
};

interface CompanyServiceState {
  services: CompanyService[];
  currentService: CompanyService | null;
}

const initialState: CompanyServiceState = {
  services: [],
  currentService: null,
};

const companyServiceSlice = createSlice({
  name: "companyUserSlice",
  initialState,
  reducers: {
    setCompanyServices: (state, action: PayloadAction<CompanyService[]>) => {
      state.services = action.payload;
    },

    setCurrentService: (state, action: PayloadAction<CompanyService>) => {
      state.currentService = action.payload;
      const isServerSide = typeof document === "undefined";
      if (!isServerSide) {
        setCurrentServiceCookie(state.currentService.sysAccountNo);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      companyServiceApi.endpoints.loadServices.matchFulfilled,
      (state, action) => {
        state.services = action.payload;
      }
    );
    builder.addMatcher(
      companyServiceApi.endpoints.editService.matchFulfilled,
      (state, action) => {
        state.currentService = action.payload;
      }
    );
  },
});

export const companyServiceActions = companyServiceSlice.actions;
export default companyServiceSlice.reducer;
